import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SubscriptionsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.568 14.608L21.152 4L22.568 5.416L10.568 17.416L5 11.848L6.392 10.432L10.568 14.608Z'
            />
            <Path
                fill='currentColor'
                d='M16 4C16.7807 4 17.5092 4.22367 18.1249 4.61044L16.6181 6.09733C16.4234 6.03415 16.2157 6 16 6H6C4.89543 6 4 6.89543 4 8V17C4 18.1046 4.89543 19 6 19H16C17.1046 19 18 18.1046 18 17V12.32L20 10.347V17C20 19.2091 18.2091 21 16 21H6C3.79086 21 2 19.2091 2 17V8C2 5.79086 3.79086 4 6 4H16Z'
            />
        </>
    ),
})

SubscriptionsIcon.displayName = 'SubscriptionsIcon'
